import PromoTileWrapper from "../PromoTileWrapper";
import PropTypes from "prop-types";
import {
  FLOOR_MEN,
  FLOOR_WOMEN
} from "../../../../../state/modules/config/constants";
import styles from "./PromoTile.css";

const config = {
  COM: {
    translations: {
      up_to_50_off: "UP TO 50% OFF ",
      wardrobe_wins: "WARDROBE WINS!",
      shop_now: "SHOP NOW",
      tnc: "Ts&Cs apply."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/men/ctas/generic-promos/promotion-7/cat/?cid=28239#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/women/ctas/generic-promos/promotion-3/cat/?cid=28023#ctaref-plp-tile"
    }
  },
  US: {
    translations: {
      up_to_50_off: "UP TO 50% OFF",
      wardrobe_wins: "WARDROBE WINS!",
      shop_now: "SHOP NOW",
      tnc: "Ts&Cs apply."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/us/men/ctas/generic-promos/promotion-7/cat/?cid=28239#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/us/women/ctas/generic-promos/promotion-3/cat/?cid=28023#ctaref-plp-tile"
    }
  },
  FR: {
    translations: {
      up_to_50_off: "JUSQU'À -50 % SUR",
      wardrobe_wins: "LES STARS DU STYLE!",
      shop_now: "SHOPPER",
      tnc: "Voir conditions."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/fr/homme/ctas/promos-generiques/promotion-7/cat/?cid=28239#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/fr/femme/ctas/promos-generiques/promotion-3/cat/?cid=28023#ctaref-plp-tile"
    }
  },
  DE: {
    translations: {
      up_to_50_off: "BIS ZU -50% AUF",
      wardrobe_wins: "MEGA TEILE!",
      shop_now: "JETZT SHOPPEN",
      tnc: "Es gelten die AGB."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/de/herren/ctas/generic-promos/werbeaktion-7/cat/?cid=28239#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/de/damen/ctas/generic-promos/werbeaktion-3/cat/?cid=28023#ctaref-plp-tile"
    }
  }
};

const PromoTile = ({ storeCode, floor }) => {
  const {
    translations: { up_to_50_off, wardrobe_wins, shop_now, tnc },
    FLOOR_TO_URL_MAPPING
  } = config[storeCode];
  const linkUrl = FLOOR_TO_URL_MAPPING[floor];

  return (
    <PromoTileWrapper linkUrl={linkUrl}>
      <div className={styles.promoTile}>
        <div className={styles.up_to_50_off}>{up_to_50_off}</div>
        <div className={styles.wardrobe_wins}>{wardrobe_wins}</div>
        <div className={styles.shop_now_wrapper}>
          <div className={styles.shop_now}>{shop_now}</div>
          <div className={styles.tnc}>{tnc}</div>
        </div>
      </div>
    </PromoTileWrapper>
  );
};

PromoTile.propTypes = {
  storeCode: PropTypes.string.isRequired,
  floor: PropTypes.string.isRequired
};

export default PromoTile;
